// Mock data for Careers page

export const careersData = {
  companyReviews: [
    {
      id: 1,
      author: 'Alex P.',
      role: 'Software Engineer',
      rating: 5,
      date: '2 months ago',
      text: 'Amazing culture and great work-life balance. The team is collaborative and leadership truly cares about employee growth.'
    },
    {
      id: 2,
      author: 'Maria S.',
      role: 'Product Manager',
      rating: 5,
      date: '4 months ago',
      text: 'Best decision I ever made joining bHyyve. Innovative projects, supportive team, and competitive compensation.'
    },
    {
      id: 3,
      author: 'Jordan K.',
      role: 'UX Designer',
      rating: 5,
      date: '6 months ago',
      text: 'Love working here! Creative freedom, modern tech stack, and a mission I truly believe in.'
    },
    {
      id: 4,
      author: 'Priya M.',
      role: 'Customer Success',
      rating: 5,
      date: '8 months ago',
      text: 'Fantastic onboarding experience and continuous learning opportunities. Management is transparent and communicative.'
    }
  ],
  jobs: [
    {
      id: 1,
      title: 'Senior Full Stack Developer',
      department: 'Engineering',
      location: 'Toronto, ON (Hybrid)',
      type: 'Full-time',
      description: 'Join our engineering team to build scalable solutions for Ontario\'s fastest-growing service platform.',
      requirements: [
        '5+ years of full-stack development experience',
        'Proficiency in React, Node.js, and MongoDB',
        'Experience with cloud platforms (AWS/GCP)',
        'Strong problem-solving and communication skills'
      ]
    },
    {
      id: 2,
      title: 'Product Manager',
      department: 'Product',
      location: 'Toronto, ON (Hybrid)',
      type: 'Full-time',
      description: 'Lead product strategy and roadmap for our core booking platform serving thousands of daily users.',
      requirements: [
        '3+ years of product management experience',
        'Experience in marketplace or on-demand platforms',
        'Strong analytical and data-driven decision making',
        'Excellent stakeholder management skills'
      ]
    },
    {
      id: 3,
      title: 'UX/UI Designer',
      department: 'Design',
      location: 'Toronto, ON (Hybrid)',
      type: 'Full-time',
      description: 'Design delightful experiences for customers and service providers on mobile and web platforms.',
      requirements: [
        '3+ years of UX/UI design experience',
        'Strong portfolio demonstrating mobile-first design',
        'Proficiency in Figma and design systems',
        'Experience with user research and testing'
      ]
    },
    {
      id: 4,
      title: 'Customer Success Manager',
      department: 'Customer Success',
      location: 'Ottawa, ON (Remote)',
      type: 'Full-time',
      description: 'Be the champion for our customers, ensuring they get maximum value from bHyyve.',
      requirements: [
        '2+ years in customer success or account management',
        'Excellent communication and problem-solving skills',
        'Experience with CRM tools (Salesforce, HubSpot)',
        'Passion for helping customers succeed'
      ]
    },
    {
      id: 5,
      title: 'Marketing Manager',
      department: 'Marketing',
      location: 'Toronto, ON (Hybrid)',
      type: 'Full-time',
      description: 'Drive growth through innovative marketing campaigns and brand partnerships.',
      requirements: [
        '4+ years of digital marketing experience',
        'Experience with performance marketing and SEO',
        'Strong analytical skills and data-driven approach',
        'Creative thinking and excellent writing skills'
      ]
    },
    {
      id: 6,
      title: 'Business Development Representative',
      department: 'Sales',
      location: 'Toronto, ON (Hybrid)',
      type: 'Full-time',
      description: 'Help expand our network of service providers across Ontario.',
      requirements: [
        '1-2 years of sales or BD experience',
        'Strong interpersonal and negotiation skills',
        'Self-motivated and results-driven',
        'Experience in marketplace or platform business a plus'
      ]
    }
  ],
  benefits: [
    'Competitive salary and equity',
    'Comprehensive health and dental benefits',
    'Flexible work arrangements',
    'Professional development budget',
    'Team events and activities',
    'Modern office space in downtown Toronto'
  ]
};